import TestsList from "./TestsList";

export default function DoctorTestsView({
  tests,
  isLoading,
  onEdit,
  onDelete,
}) {
  return (
    <div className="space-y-6">
      {/* Tests List */}
      <TestsList
        tests={tests}
        isLoading={isLoading}
        onEditTest={onEdit}
        onDeleteTest={onDelete}
        isPatientView={false}
      />
    </div>
  );
}
